import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { useStore } from '@gx-vuex'
import NewsRecommend from '@/components/desktop/NewsRecommend'
import useSuggestList from '../../hooks/useSuggestList'
import HomeColumn from '@/components/HomeColumn.vue'

export default defineComponent({
  props: {
    type: String as PropType<'suggest' | 'recommond'>,
    subTitle: {
      type: String as PropType<'Suggested for You' | 'RECOMMEND'>,
      default: 'Suggested for You'
    }
  },
  setup(props) {
    const store = useStore()

    const objectType = document.querySelector('body').getAttribute('data-objectType')

    const suggestList = useSuggestList(8, props.type || 'suggest')

    const firstBig = computed(() => suggestList.value.length >=5  && !!suggestList.value[0]?.imageShow)

    return () => {
      return (
        <div class={[ suggestList.value.length ? 'mb-40px mt-40px' : '' ]}>
          {suggestList.value.length > 0 && (
              <HomeColumn title={(!!store.global.details?.serials?.serialsId && objectType == '1') ? 'Suggested for You' : props.subTitle} childrenTop={30} isContainer={false}>
              <NewsRecommend dataSource={suggestList.value} firstBig={firstBig.value} allowRecommond showNumber={false} />
            </HomeColumn>
          )}
        </div>
      )
    }
  }
})
